var $e096aa0a23f85b04$exports = {};
$e096aa0a23f85b04$exports = {
    "collectionLabel": `Empfehlungen`
};


export {$e096aa0a23f85b04$exports as default};
//# sourceMappingURL=de-DE.module.js.map
